import rules from "../rules";

export default {
    cc     : [
        rules.required('Credit card')
    ],
    expiration_month      : [
        rules.required('Month')
    ],
    expiration_year: [
        rules.required('Year')
    ],
    cvv           : [
        rules.required('CVV'),
    ],
    agreement :[
        m => m || "Please accept Terms and Conditions!"
    ]
}
